import { takeLatest, call, put, delay, select } from 'redux-saga/effects';
import UserService from 'shared/services/UserService';
import { IUser } from 'shared/interfaces/user.interface';
import { TAction } from 'shared/types';
import {
  getAffAdmins,
  createAffiliateAdmin,
  getAffiliateAdmins,
  createAffiliateAdminSuccess,
  removeAffiliateAdmin,
  deleteAffiliateAdmin,
  updateAffiliateAdminSuccess,
  updateAffiliateAdminFail,
  updateAffiliateAdmin
} from './affiliateAdmins.redux';
import { openNotificationMessage } from 'shared/utils/NotificationMessages';
import { NotificationMessages } from 'shared/enums';
import { AxiosResponse } from 'axios';
import { IState } from 'shared/interfaces/state.interface';

function* getAllAffiliateAdmins({ payload }: TAction<{ status?: string }>) {
  try {
    const affiliateAdmins: IUser[] = yield call(
      UserService.getAffiliateAdmins,
      payload
    );
    yield put(getAffiliateAdmins(affiliateAdmins));
  } catch (error) {
    console.log('error', error);
  }
}

function* createNewAffiliateAdmin({ payload }: TAction<IUser>) {
  try {
    const result: AxiosResponse<IUser> = yield call(
      UserService.createAffAdmin,
      payload
    );
    yield put(createAffiliateAdminSuccess(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'User was successfully created.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield put(updateAffiliateAdminFail());
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message || 'User creation was unsuccessful.'
    });
  }
}

function* handleRemoveAffiliateAdmin({ payload }: TAction<string>) {
  try {
    yield call(UserService.deleteAffAdmin, payload);
    yield put(removeAffiliateAdmin(payload));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'User was successfully deleted.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message: error?.response?.data?.message || 'Unable to delete user.'
    });
  }
}
function* handleUpdateAffiliateAdmin({
  payload
}: TAction<{
  data: IUser;
  id: string;
}>) {
  try {
    const result: AxiosResponse<IUser> = yield call(
      UserService.updateAffAdmin,
      payload
    );
    yield put(updateAffiliateAdminSuccess(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'User data was successfully updated.'
    });
    yield delay(1000);
    const { affiliateAdmins }: { affiliateAdmins: IUser[] } = yield select(
      (state: IState) => state.affiliateAdmins
    );
    yield put(getAffiliateAdmins(affiliateAdmins));
  } catch (error: any) {
    yield put(updateAffiliateAdminFail());
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message || 'User updating was unsuccesful.'
    });
  }
}
function* AffiliateAdmins() {
  yield takeLatest(getAffAdmins.type, getAllAffiliateAdmins);
  yield takeLatest(createAffiliateAdmin.type, createNewAffiliateAdmin);
  yield takeLatest(deleteAffiliateAdmin.type, handleRemoveAffiliateAdmin);
  yield takeLatest(updateAffiliateAdmin.type, handleUpdateAffiliateAdmin);
}

export default AffiliateAdmins;
